import { Link } from "react-router-dom";

const Table2 = ({ data }) => {
	return (
		<table className="approved assigned">
			<thead>
				<tr>
					<th colSpan="5" className="hdg">
						Guest Statuses Snapshot
					</th>
				</tr>
			</thead>
			<thead>
				<tr>
					<td className="left">Guest Name</td>
					<td className="status">Golf</td>
					<td className="status">Sporting Clays</td>
					<td className="status">Gift Package</td>
					<td className="status">Welcome Party</td>
				</tr>
			</thead>
			<tbody>
				{data.map((item, index) => {
					return item.name ? (
						<tr key={index}>
							<td className="left">
								{item.name === "donated" ? (
									<span className="working">Donated Back</span>
								) : (
									<Link to={`/dashboard/guest/${item.id}`}>{item.name}</Link>
								)}
							</td>

							<td className="center">
								{item.golf === 1 ? (
									<i className="fa fa-check-circle fa-lg success" />
								) : item.golf === 2 ? (
									<i className="fa fa-hourglass-o fa-lg working" />
								) : item.golf === 4 ? (
									<i className="fa fa-clock-o fa-lg notice" />
								) : (
									""
								)}
							</td>
							<td className="center">
								{item.sporting === 1 ? (
									<i className="fa fa-check-circle fa-lg success" />
								) : item.sporting === 2 ? (
									<i className="fa fa-hourglass-o fa-lg working" />
								) : item.sporting === 4 ? (
									<i className="fa fa-clock-o fa-lg notice" />
								) : (
									""
								)}
							</td>
							<td className="center">
								{item.gift === 1 ? (
									<i className="fa fa-check-circle fa-lg success" />
								) : item.gift === 2 ? (
									<i className="fa fa-hourglass-o fa-lg working" />
								) : item.gift === 4 ? (
									<i className="fa fa-clock-o fa-lg notice" />
								) : (
									""
								)}
							</td>
							<td className="center">
								{item.welcome === 1 ? (
									<i className="fa fa-check-circle fa-lg success" />
								) : item.welcome === 2 ? (
									<i className="fa fa-hourglass-o fa-lg working" />
								) : item.welcome === 4 ? (
									<i className="fa fa-clock-o fa-lg notice" />
								) : (
									""
								)}
							</td>
						</tr>
					) : null;
				})}
			</tbody>
		</table>
	);
};

export default Table2;
